module.exports = __webpack_public_path__ + "static/img/320x200-blade.6ea41e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/320x200-blade.png
// module id = F4fA
// module chunks = 1